export default "__VITE_ASSET__SEvRW4WI__"